<div class="inline-block icon-button">
    <button type="button"
            *ngIf="callback.observers.length > 0"
            [attr.aria-label]="monAriaLabel || tooltip"
            ngbTooltip="{{ tooltip }}"
            [triggers]="'focus hover'"
            (click)="onCallback($event)"
            [disabled]="disabled"
            class="inner-r-l-small"
            [ngClass]="{
                'text-grey': disabled,
                'btn button-monsido-icon': callback.observers.length > 0
            }">
        <span class="vcenter {{ faIcon }} fa-lg outer-r-mini" [ngClass]="evaluate(true)" aria-hidden="true"></span>
        <span class="sr-only">{{ monAriaIconText || '' }}</span>
        <span [hidden]="disabled" class="vcenter" [ngClass]="evaluate(changeTextColor)">{{ number | monNumber }}</span>
    </button>
    <div *ngIf="callback.observers.length === 0"
         ngbTooltip="{{ tooltip }}"
         tabindex="0"
         [attr.aria-label]="monAriaLabel"
         [triggers]="'focus hover'"
         class="text-center inner-r-l-small">
        <span class="vcenter {{ faIcon }} fa-lg outer-r-mini" [ngClass]="evaluate(true)"></span>
        <span [hidden]="disabled" class="vcenter" [ngClass]="evaluate(changeTextColor)">{{ number | monNumber }}</span>
    </div>
</div>


